import React,{useState} from 'react';
import {func, instanceOf} from "prop-types";
import DatePickerDropDown from './DatePickerDropDown';
import { CalendarIcon } from './HeroIcons';
const DatePickerInputBox = ({selectedDate, setSelectedDate}) => {

    const [isOpen, setIsOpen] = useState(false);


    const handleOpenModal = () => setIsOpen(true);
    const handleCloseModal = () => setIsOpen(false);

    const toggleDropdown = () => {
        if(isOpen){
          handleCloseModal()
        }else{
          handleOpenModal()
        }

    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleDropdown();
        }
    };

    return (
        <>
            <div role="button" tabIndex={0} onClick={toggleDropdown} onKeyDown={handleKeyDown} style={{ backgroundColor: '#FFFFFF', border: '0.911px solid rgba(110,108,113,0.3)', borderRadius: '5px', color: '#6E6C71', minHeight: '37px' }} className="cursor-pointer flex-1 px-3 flex items-center justify-between">
                <p className="font-light inline-block" style={{ color: '#6E6C71', fontSize: '12px' }}>{selectedDate ? selectedDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) :"Date"}</p>
                <CalendarIcon
                    data-testid={'calendar-icon'}
                    className="cursor-pointer ml-2"
                    style={{ color: '#6E6C71' }}
                />
            </div>
        {isOpen && (
            <div style={{ position: 'absolute', top: 'calc(100%-1.5rem)', left: "24px", zIndex: 20 }}>
                <DatePickerDropDown
                    handleCloseModal = {handleCloseModal}
                    selectedDate = {selectedDate}
                    setSelectedDate = {setSelectedDate}
                />
            </div>
        )}
        </>
    )
}

DatePickerInputBox.propTypes = {
    selectedDate: instanceOf(Date),
    setSelectedDate: func
};

export default DatePickerInputBox;